import { css, styled } from 'styled-components';
import { SvgIconProps } from './types';

const StyledSvgIcon = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    !['src', 'rotate', 'width', 'height', 'bgColor', 'bgImage'].includes(prop),
})<SvgIconProps>`
  ${(props) => css`
    width: ${props.width};
    height: ${props.height};
    -webkit-mask: url(${props.src}) center/cover no-repeat;
    mask: url(${props.src}) center/cover no-repeat;
    transform: rotate(${props.rotate}deg);
    background-color: ${props.bgColor};
    background-image: ${props.bgImage};
  `}
`;

export default StyledSvgIcon;
